/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ 412: /***/ (__unused_webpack_module, exports) => {
      "use strict";
      var __webpack_unused_export__;

      __webpack_unused_export__ = true;
      var EventHandler = /** @class */ (function () {
        function EventHandler() {
          this.events = [];
        }
        EventHandler.prototype.register = function (el, event, listener) {
          if (!el || !event || !listener) return null;
          this.events.push({ el: el, event: event, listener: listener });
          el.addEventListener(event, listener);
          return { el: el, event: event, listener: listener };
        };
        EventHandler.prototype.unregister = function (_a) {
          var el = _a.el,
            event = _a.event,
            listener = _a.listener;
          if (!el || !event || !listener) return null;
          this.events = this.events.filter(function (e) {
            return el !== e.el || event !== e.event || listener !== e.listener;
          });
          el.removeEventListener(event, listener);
          return { el: el, event: event, listener: listener };
        };
        EventHandler.prototype.unregisterAll = function () {
          this.events.forEach(function (_a) {
            var el = _a.el,
              event = _a.event,
              listener = _a.listener;
            return el.removeEventListener(event, listener);
          });
          this.events = [];
        };
        return EventHandler;
      })();
      exports.Z = EventHandler;

      /***/
    },

    /***/ 347: /***/ () => {
      class VariantSelection extends HTMLElement {
        static get observedAttributes() {
          return ["variant"];
        }

        constructor() {
          super();
          this._loaded = false;
          this._productFetcher = Promise.resolve(false);

          this._onMainElChange = (event) => {
            this.variant = event.currentTarget.value;
          };

          const mainInputEl = this.querySelector("input[data-variants]");
          this._mainEl = mainInputEl || this.querySelector("select[data-variants]");
        }

        set variant(value) {
          if (value) {
            this.setAttribute("variant", value);
          } else {
            this.removeAttribute("variant");
          }
        }

        get variant() {
          return this.getAttribute("variant");
        }

        connectedCallback() {
          this._productFetcher = this._fetchProduct();
          const mainInputEl = this.querySelector("input[data-variants]");
          this._mainEl = mainInputEl || this.querySelector("select[data-variants]");

          this._mainEl.addEventListener("change", this._onMainElChange);

          this.variant = this._mainEl.value;
        }

        disconnectedCallback() {
          this._mainEl.removeEventListener("change", this._onMainElChange);

          this._mainEl = null;
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;

          switch (name) {
            case "variant":
              this._changeVariant(newValue);

              break;
          }
        }

        getProduct() {
          return this._loaded ? Promise.resolve(this._product) : this._productFetcher;
        }

        getVariant() {
          return this.getProduct()
            .then((product) => (product ? product.variants.find((v) => v.id.toString() === this.variant) || false : false))
            .catch(() => false);
        }

        getState() {
          return this.getVariant().then((variant) => (variant ? "selected" : this.getAttribute("variant")));
        }

        _changeVariant(value) {
          this._dispatchEvent(value).then(() => {
            this._mainEl.value = value;
          });
        }

        _fetchProduct() {
          return fetch(this.getAttribute("product-url"))
            .then((response) => response.json())
            .then((product) => {
              this._product = product;
              return product;
            })
            .catch(() => {
              this._product = null;
            })
            .finally(() => {
              this._loaded = true;
            });
        }

        _dispatchEvent(value) {
          return this.getProduct().then((product) => {
            const variant = product ? product.variants.find((v) => v.id.toString() === value) || false : false;
            const state = variant ? "selected" : value;
            const event = new CustomEvent("variant-change", {
              detail: {
                product,
                variant,
                state,
              },
            });
            this.dispatchEvent(event);
          });
        }
      }

      const valueElementType = {
        select: "option",
        radio: 'input[type="radio"]',
      };

      function setSelectedOptions(selectOptions, radioOptions, selectedOptions) {
        selectOptions.forEach(({ option }) => {
          option.value = selectedOptions[parseInt(option.dataset.variantOptionIndex, 10)];
        });
        radioOptions.forEach(({ values }) => {
          values.forEach((value) => {
            value.checked = value.value === selectedOptions[parseInt(value.dataset.variantOptionValueIndex, 10)];
          });
        });
      }

      function getOptions(optionsEls) {
        const select = [];
        const radio = [];

        for (let i = 0; i < optionsEls.length; i++) {
          const optionEl = optionsEls[i];
          const wrappers = optionEl.matches("[data-variant-option-value-wrapper]")
            ? [optionEl]
            : Array.prototype.slice.call(optionEl.querySelectorAll("[data-variant-option-value-wrapper]"));
          const values = optionEl.matches("[data-variant-option-value]") ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll("[data-variant-option-value]"));
          if (!values.length) break;
          const option = {
            option: optionEl,
            wrappers,
            values,
          };

          if (values[0].matches(valueElementType.select)) {
            select.push(option);
          } else if (values[0].matches(valueElementType.radio)) {
            radio.push(option);
          }
        }

        return {
          select,
          radio,
        };
      }

      function getSelectedOptions(product, selectOptions, radioOptions) {
        const options = product.options.map(() => "not-selected");
        selectOptions.forEach(({ option }) => {
          if (option.value !== "not-selected") {
            options[parseInt(option.dataset.variantOptionIndex, 10)] = option.value;
          }
        });
        radioOptions.forEach(({ values }) => {
          values.forEach((value) => {
            if (value.checked) {
              options[parseInt(value.dataset.variantOptionValueIndex, 10)] = value.value;
            }
          });
        });
        return options;
      }

      function getVariantFromSelectedOptions(variants, selectedOptions) {
        for (let i = 0; i < variants.length; i++) {
          const variant = variants[i];
          const isVariant = variant.options.every((option, index) => option === selectedOptions[index]);
          if (isVariant) return variant; // We found the variant
        }

        return false;
      }

      function _getVariant(variants, options) {
        return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
      }

      function _setOptionsMap(product, selectedOptions, optionsMap, option1, option2 = null, option3 = null) {
        const updatedOptionsMap = { ...optionsMap };
        const options = [option1, option2, option3].filter((option) => !!option);

        const variant = _getVariant(product.variants, options);

        const variantOptionMatches = options.filter((option, index) => option === selectedOptions[index]).length;
        const isCurrentVariant = variantOptionMatches === product.options.length;
        const isNeighbor = variantOptionMatches === product.options.length - 1;

        for (let i = 0; i < options.length; i++) {
          const option = options[i];

          if (option) {
            let { setByCurrentVariant, setByNeighbor, accessible, available } = optionsMap[i][option];

            if (variant) {
              accessible = variant.available || accessible; // The current variant is always
              // the priority for option availability

              if (isCurrentVariant) {
                setByCurrentVariant = true;
                ({ available } = variant);
              } else if (!setByCurrentVariant && isNeighbor) {
                // If the variant is a neighbor
                // And the option doesn't belong to the variant
                // Use its availability information for the option
                // If multiple neighbors exist, prefer true
                available = setByNeighbor ? available || variant.available : variant.available;
                setByNeighbor = true;
              }
            } else if (isCurrentVariant) {
              // Catch case where current variant doesn't exist
              // Ensure availability is false
              setByCurrentVariant = true;
              available = false;
            } else if (!setByCurrentVariant && isNeighbor) {
              // Catch case where neighbor doesn't exist
              // Ensure availability is false
              // If multiple neighbors exist, prefer true
              available = setByNeighbor ? available : false;
              setByNeighbor = true;
            } // If the option isn't set by either
            // the current variant or a neighbor
            // default to general accessibility

            if (!setByCurrentVariant && !setByNeighbor) {
              available = accessible;
            }

            updatedOptionsMap[i][option] = {
              setByCurrentVariant,
              setByNeighbor,
              accessible,
              available,
            };
          }
        }

        return updatedOptionsMap;
      }

      function getOptionsAccessibility(product, selectedOptions) {
        let optionsMap = product.options.map(() => ({}));

        for (let i = 0; i < product.options.length; i++) {
          for (let j = 0; j < product.variants.length; j++) {
            const variant = product.variants[j];
            const option = variant.options[i];
            optionsMap[i][option] = {
              setByCurrentVariant: false,
              setByNeighbor: false,
              accessible: false,
              available: false,
            };
          }
        }

        const option1Values = optionsMap.length >= 1 ? Object.keys(optionsMap[0]) : [];
        const option2Values = optionsMap.length >= 2 ? Object.keys(optionsMap[1]) : [];
        const option3Values = optionsMap.length >= 3 ? Object.keys(optionsMap[2]) : [];
        option1Values.forEach((option1Value) => {
          option2Values.forEach((option2Value) => {
            option3Values.forEach((option3Value) => {
              optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value, option3Value);
            });

            if (!option3Values.length) {
              optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value);
            }
          });

          if (!option2Values.length) {
            optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value);
          }
        });
        return optionsMap;
      }

      function updateOptions(product, selectOptions, radioOptions, selectedOptions, disableUnavailableOptions, removeUnavailableOptions) {
        const options = [...selectOptions, ...radioOptions];

        if (options.length === 0) {
          return;
        }

        const optionsAccessibility = getOptionsAccessibility(product, selectedOptions); // Iterate over each option type

        for (let i = 0; i < product.options.length; i++) {
          // Corresponding select dropdown, if it exists
          const optionValues = options.find(({ option }) => {
            if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
              return true;
            }

            return false;
          });

          if (optionValues) {
            const fragment = document.createDocumentFragment();
            const { option, wrappers, values } = optionValues;

            for (let j = values.length - 1; j >= 0; j--) {
              const wrapper = wrappers[j];
              const optionValue = values[j];
              const { value } = optionValue;
              const { available } = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false;
              const { accessible } = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false;
              const isChooseOption = value === "not-selected"; // Option element to indicate unchosen option
              // Disable unavailable options

              optionValue.disabled = isChooseOption || (disableUnavailableOptions && !accessible);
              optionValue.dataset.variantOptionAccessible = accessible;
              optionValue.dataset.variantOptionAvailable = available;

              if (!removeUnavailableOptions || accessible || isChooseOption) {
                fragment.insertBefore(wrapper, fragment.firstElementChild);
              }
            }

            option.innerHTML = "";
            option.appendChild(fragment);
            const chosenValue = values.find((value) => value.selected || value.checked);
            option.dataset.variantOptionChosenValue = chosenValue && chosenValue.value !== "not-selected" ? chosenValue.value : false;
          }
        }
      }

      class OptionsSelection extends HTMLElement {
        static get observedAttributes() {
          return ["variant-selection", "disable-unavailable", "remove-unavailable"];
        }

        static synchronize(mainOptionsSelection) {
          const mainVariantSelection = mainOptionsSelection.getVariantSelection(); // Fast return if we aren't associated with a variant selection

          if (!mainVariantSelection) return Promise.resolve(false);
          return mainOptionsSelection
            .getSelectedOptions()
            .then((selectedOptions) => {
              // Update all other options selects associated with the same variant ui
              const optionsSelections = document.querySelectorAll("options-selection");
              optionsSelections.forEach((optionsSelection) => {
                if (optionsSelection !== mainOptionsSelection && optionsSelection.getVariantSelection() === mainVariantSelection) {
                  optionsSelection.setSelectedOptions(selectedOptions);
                }
              });
            })
            .then(() => true);
        }

        constructor() {
          super();
          this.style.display = "";
          this._events = [];
          this._onChangeFn = this._onOptionChange.bind(this);
          this._optionsEls = this.querySelectorAll("[data-variant-option]");
          ({ select: this._selectOptions, radio: this._radioOptions } = getOptions(this._optionsEls));

          this._associateVariantSelection(this.getAttribute("variant-selection"));
        }

        set variantSelection(value) {
          if (value) {
            this.setAttribute("variant-selection", value);
          } else {
            this.removeAttribute("variant-selection");
          }
        }

        get variantSelection() {
          return this.getAttribute("variant-selection");
        }

        connectedCallback() {
          this._optionsEls = this.querySelectorAll("[data-variant-option]");
          ({ select: this._selectOptions, radio: this._radioOptions } = getOptions(this._optionsEls));

          this._associateVariantSelection(this.getAttribute("variant-selection"));

          this._selectOptions.forEach(({ option }) => {
            option.addEventListener("change", this._onChangeFn);

            this._events.push({
              el: option,
              fn: this._onChangeFn,
            });
          });

          this._radioOptions.forEach(({ values }) => {
            values.forEach((value) => {
              value.addEventListener("change", this._onChangeFn);

              this._events.push({
                el: value,
                fn: this._onChangeFn,
              });
            });
          });

          this._onOptionChange();
        }

        disconnectedCallback() {
          this._resetOptions();

          this._events.forEach(({ el, fn }) => el.removeEventListener("change", fn));

          this._events = [];
        }

        attributeChangedCallback(name, _oldValue, newValue) {
          switch (name) {
            case "variant-selection":
              this._associateVariantSelection(newValue);

              break;

            case "disable-unavailable":
            case "remove-unavailable":
              this._updateOptions(this.hasAttribute("disable-unavailable"), this.hasAttribute("remove-unavailable"));

              break;
          }
        }

        getSelectedOptions() {
          if (!this._variantSelection) return Promise.resolve(null);
          return this._variantSelection.getProduct().then((product) => {
            if (!product) return null;
            return getSelectedOptions(product, this._selectOptions, this._radioOptions);
          });
        }

        getVariantSelection() {
          return this._variantSelection;
        }

        setSelectedOptions(selectedOptions) {
          setSelectedOptions(this._selectOptions, this._radioOptions, selectedOptions);
          return this._updateOptions(this.hasAttribute("disable-unavailable"), this.hasAttribute("remove-unavailable"), selectedOptions);
        }

        _associateVariantSelection(id) {
          this._variantSelection = id ? document.getElementById(id) : this.closest("variant-selection");
        }

        _updateLabels() {
          // Update any labels
          for (let i = 0; i < this._optionsEls.length; i++) {
            const optionsEl = this._optionsEls[i];
            let optionsNameEl = null;
            let { parentElement } = optionsEl;

            while (parentElement && !optionsNameEl) {
              const tmpOptionsNameEl = parentElement.querySelector("[data-variant-option-name]");

              if (tmpOptionsNameEl) {
                optionsNameEl = tmpOptionsNameEl;
              }

              ({ parentElement } = parentElement);
            }

            if (optionsNameEl) {
              optionsNameEl.dataset.variantOptionChosenValue = optionsEl.dataset.variantOptionChosenValue;

              if (optionsEl.dataset.variantOptionChosenValue !== "false") {
                optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionName;
                const optionNameValueSpan = optionsNameEl.querySelector("span");

                if (optionNameValueSpan) {
                  optionNameValueSpan.innerHTML = optionsEl.dataset.variantOptionChosenValue;
                }
              } else {
                optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionChooseName;
              }
            }
          }
        }

        _resetOptions() {
          return this._updateOptions(false, false);
        }

        _updateOptions(disableUnavailableOptions, removeUnavailableOptions, selectedOptions = null) {
          if (!this._variantSelection) return Promise.resolve(false);
          return this._variantSelection
            .getProduct()
            .then((product) => {
              updateOptions(
                product,
                this._selectOptions,
                this._radioOptions,
                selectedOptions || getSelectedOptions(product, this._selectOptions, this._radioOptions),
                disableUnavailableOptions,
                removeUnavailableOptions
              );

              this._updateLabels();
            })
            .then(() => true);
        }

        _updateVariantSelection(product, selectedOptions) {
          if (!this._variantSelection) return;
          const variant = getVariantFromSelectedOptions(product.variants, selectedOptions);
          const isNotSelected = selectedOptions.some((option) => option === "not-selected"); // Update master select

          if (variant) {
            this._variantSelection.variant = variant.id;
          } else {
            this._variantSelection.variant = isNotSelected ? "not-selected" : "unavailable";
          }
        }

        _onOptionChange() {
          if (!this._variantSelection) return;

          this._variantSelection.getProduct().then((product) => {
            if (!product) return;
            const selectedOptions = getSelectedOptions(product, this._selectOptions, this._radioOptions);

            this._updateOptions(this.hasAttribute("disable-unavailable"), this.hasAttribute("remove-unavailable"), selectedOptions);

            this._updateVariantSelection(product, selectedOptions);

            OptionsSelection.synchronize(this);
          });
        }
      }

      if (!customElements.get("variant-selection")) {
        customElements.define("variant-selection", VariantSelection);
      }

      if (!customElements.get("options-selection")) {
        customElements.define("options-selection", OptionsSelection);
      }

      /***/
    },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict";

    // NAMESPACE OBJECT: ./node_modules/@shopify/theme-addresses/theme-addresses.js
    var theme_addresses_namespaceObject = {};
    __webpack_require__.r(theme_addresses_namespaceObject);

    // EXTERNAL MODULE: ./build_tools/ejected_modules/@pixelunion/shopify-variants-ui/dist/index.es.js
    var index_es = __webpack_require__(347); // CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/addressForm.js
    var FIELD_REGEXP = /({\w+})/g;
    var LINE_DELIMITER = "_";
    var INPUT_SELECTORS = {
      lastName: '[name="address[last_name]"]',
      firstName: '[name="address[first_name]"]',
      company: '[name="address[company]"]',
      address1: '[name="address[address1]"]',
      address2: '[name="address[address2]"]',
      country: '[name="address[country]"]',
      zone: '[name="address[province]"]',
      postalCode: '[name="address[zip]"]',
      city: '[name="address[city]"]',
      phone: '[name="address[phone]"]',
    };

    function AddressForm(rootEl, locale, options) {
      locale = locale || "en";
      options = options || { inputSelectors: {} };
      var formElements = loadFormElements(rootEl, mergeObjects(INPUT_SELECTORS, options.inputSelectors));

      validateElements(formElements);

      return loadShippingCountries(options.shippingCountriesOnly).then(function (shippingCountryCodes) {
        return loadCountries(locale).then(function (countries) {
          init(rootEl, formElements, filterCountries(countries, shippingCountryCodes));
        });
      });
    }

    /**
     * Runs when countries have been loaded
     */
    function init(rootEl, formElements, countries) {
      populateCountries(formElements, countries);
      var selectedCountry = formElements.country.input ? formElements.country.input.value : null;
      setEventListeners(rootEl, formElements, countries);
      handleCountryChange(rootEl, formElements, selectedCountry, countries);
    }

    /**
     * Handles when a country change: set labels, reorder fields, populate zones
     */
    function handleCountryChange(rootEl, formElements, countryCode, countries) {
      var country = getCountry(countryCode, countries);

      setLabels(formElements, country);
      reorderFields(rootEl, formElements, country);
      populateZones(formElements, country);
    }

    /**
     * Sets up event listener for country change
     */
    function setEventListeners(rootEl, formElements, countries) {
      formElements.country.input.addEventListener("change", function (event) {
        handleCountryChange(rootEl, formElements, event.target.value, countries);
      });
    }

    /**
     * Reorder fields in the DOM and add data-attribute to fields given a country
     */
    function reorderFields(rootEl, formElements, country) {
      var formFormat = country.formatting.edit;

      var countryWrapper = formElements.country.wrapper;
      var afterCountry = false;

      getOrderedField(formFormat).forEach(function (row) {
        row.forEach(function (line) {
          formElements[line].wrapper.dataset.lineCount = row.length;
          if (!formElements[line].wrapper) {
            return;
          }
          if (line === "country") {
            afterCountry = true;
            return;
          }

          if (afterCountry) {
            rootEl.append(formElements[line].wrapper);
          } else {
            rootEl.insertBefore(formElements[line].wrapper, countryWrapper);
          }
        });
      });
    }

    /**
     * Update labels for a given country
     */
    function setLabels(formElements, country) {
      Object.keys(formElements).forEach(function (formElementName) {
        formElements[formElementName].labels.forEach(function (label) {
          label.textContent = country.labels[formElementName];
        });
      });
    }

    /**
     * Add right countries in the dropdown for a given country
     */
    function populateCountries(formElements, countries) {
      var countrySelect = formElements.country.input;
      var duplicatedCountrySelect = countrySelect.cloneNode(true);

      countries.forEach(function (country) {
        var optionElement = document.createElement("option");
        optionElement.value = country.code;
        optionElement.textContent = country.name;
        duplicatedCountrySelect.appendChild(optionElement);
      });

      countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;

      if (countrySelect.dataset.default) {
        countrySelect.value = countrySelect.dataset.default;
      }
    }

    /**
     * Add right zones in the dropdown for a given country
     */
    function populateZones(formElements, country) {
      var zoneEl = formElements.zone;
      if (!zoneEl) {
        return;
      }

      if (country.zones.length === 0) {
        zoneEl.wrapper.dataset.ariaHidden = "true";
        zoneEl.input.innerHTML = "";
        return;
      }

      zoneEl.wrapper.dataset.ariaHidden = "false";

      var zoneSelect = zoneEl.input;
      var duplicatedZoneSelect = zoneSelect.cloneNode(true);
      duplicatedZoneSelect.innerHTML = "";

      country.zones.forEach(function (zone) {
        var optionElement = document.createElement("option");
        optionElement.value = zone.code;
        optionElement.textContent = zone.name;
        duplicatedZoneSelect.appendChild(optionElement);
      });

      zoneSelect.innerHTML = duplicatedZoneSelect.innerHTML;

      if (zoneSelect.dataset.default) {
        zoneSelect.value = zoneSelect.dataset.default;
      }
    }

    /**
     * Will throw if an input or a label is missing from the wrapper
     */
    function validateElements(formElements) {
      Object.keys(formElements).forEach(function (elementKey) {
        var element = formElements[elementKey].input;
        var labels = formElements[elementKey].labels;

        if (!element) {
          return;
        }

        if (typeof element !== "object") {
          throw new TypeError(formElements[elementKey] + " is missing an input or select.");
        } else if (typeof labels !== "object") {
          throw new TypeError(formElements[elementKey] + " is missing a label.");
        }
      });
    }

    /**
     * Given an countryCode (eg. 'CA'), will return the data of that country
     */
    function getCountry(countryCode, countries) {
      countryCode = countryCode || "CA";
      return countries.filter(function (country) {
        return country.code === countryCode;
      })[0];
    }

    /**
     * Given a format (eg. "{firstName}{lastName}_{company}_{address1}_{address2}_{city}_{country}{province}{zip}_{phone}")
     * will return an array of how the form needs to be formatted, eg.:
     * =>
     * [
     *   ['firstName', 'lastName'],
     *   ['company'],
     *   ['address1'],
     *   ['address2'],
     *   ['city'],
     *   ['country', 'province', 'zip'],
     *   ['phone']
     * ]
     */
    function getOrderedField(format) {
      return format.split(LINE_DELIMITER).map(function (fields) {
        var result = fields.match(FIELD_REGEXP);
        if (!result) {
          return [];
        }

        return result.map(function (fieldName) {
          var newFieldName = fieldName.replace(/[{}]/g, "");

          switch (newFieldName) {
            case "zip":
              return "postalCode";
            case "province":
              return "zone";
            default:
              return newFieldName;
          }
        });
      });
    }

    /**
     * Given a rootEl where all `input`s, `select`s, and `labels` are nested, it
     * will returns all form elements (wrapper, input and labels) of the form.
     * See `FormElements` type for details
     */
    function loadFormElements(rootEl, inputSelectors) {
      var elements = {};
      Object.keys(INPUT_SELECTORS).forEach(function (inputKey) {
        var input = rootEl.querySelector(inputSelectors[inputKey]);
        elements[inputKey] = input
          ? {
              wrapper: input.parentElement,
              input: input,
              labels: document.querySelectorAll('[for="' + input.id + '"]'),
            }
          : {};
      });

      return elements;
    }

    /**
     * If shippingCountriesOnly is set to true, will return the list of countries the
     * shop ships to. Otherwise returns null.
     */
    function loadShippingCountries(shippingCountriesOnly) {
      if (!shippingCountriesOnly) {
        // eslint-disable-next-line no-undef
        return Promise.resolve(null);
      }

      var response = fetch(location.origin + "/meta.json");

      return response
        .then(function (res) {
          return res.json();
        })
        .then(function (meta) {
          // If ships_to_countries has * in the list, it means the shop ships to
          // all countries
          return meta.ships_to_countries.indexOf("*") !== -1 ? null : meta.ships_to_countries;
        })
        .catch(function () {
          return null;
        });
    }

    /**
     * Only returns countries that are in includedCountryCodes
     * Returns all countries if no includedCountryCodes is passed
     */
    function filterCountries(countries, includedCountryCodes) {
      if (!includedCountryCodes) {
        return countries;
      }

      return countries.filter(function (country) {
        return includedCountryCodes.indexOf(country.code) !== -1;
      });
    } // CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js

    // EXTERNAL MODULE: ./build_tools/ejected_modules/@pixelunion/events/dist/EventHandler.js
    var EventHandler = __webpack_require__(412); // CONCATENATED MODULE: ./source/scripts/utilities/ShippingCalculator.js
    class ShippingCalculator {
      constructor({ el }) {
        this.el = el;
        this.events = new EventHandler /* default */.Z();
        this.rates = this.el.querySelector("[data-shipping-rates]");
        this.message = this.el.querySelector("[data-shipping-message]");
        this.zip = this.el.querySelector("[data-shipping-calculator-zipcode]");
        this.submit = this.el.querySelector(".get-rates");
        this.response = this.el.querySelector("[data-shipping-calculator-response]");
        this.countrySelect = this.el.querySelector("[data-shipping-calculator-country]");
        this.provinceSelect = this.el.querySelector("[data-shipping-calculator-province]");
        this.provinceContainer = this.el.querySelector("[data-shipping-calculator-province-container]");

        this.buildCalculator();
      }

      buildCalculator() {
        this.shippingCountryProvinceSelector = new theme_addresses_namespaceObject.CountryProvinceSelector(this.countrySelect.innerHTML);
        this.shippingCountryProvinceSelector.build(this.countrySelect, this.provinceSelect, {
          onCountryChange: (provinces) => {
            if (provinces.length) {
              this.provinceContainer.style.display = "block";
            } else {
              this.provinceContainer.style.display = "none";
            }

            // "Province", "State", "Region", etc. and "Postal Code", "ZIP Code", etc.
            // Even countries without provinces include a label.
            const { label, zip_label: zipLabel } = window.Countries[this.countrySelect.value];
            this.provinceContainer.querySelector('label[for="address_province"]').innerHTML = label;
            this.el.querySelector('label[for="address_zip"]').innerHTML = zipLabel;
          },
        });

        this.events.register(this.submit, "click", (e) => {
          e.preventDefault();
          this.getRates();
        });
      }

      getRates() {
        const shippingAddress = {};
        shippingAddress.country = this.countrySelect ? this.countrySelect.value : "";
        shippingAddress.province = this.provinceSelect ? this.provinceSelect.value : "";
        shippingAddress.zip = this.zip ? this.zip.value : "";

        const queryString = Object.keys(shippingAddress)
          .map((key) => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
          .join("&");

        fetch(`${window.PXUTheme.routes.cart_url}/shipping_rates.json?${queryString}`)
          .then((response) => response.json())
          .then((data) => this.displayRates(data));
      }

      displayRates(rates) {
        const propertyName = Object.keys(rates);
        this.clearRates();

        if (propertyName[0] === "shipping_rates") {
          rates.shipping_rates.forEach((rate) => {
            const rateLi = document.createElement("li");
            rateLi.innerHTML = `${rate.name}: ${this.formatPrice(rate.price)}`;
            this.rates.appendChild(rateLi);
          });

          if (rates.shipping_rates.length > 1) {
            this.message.innerHTML = `${window.PXUTheme.translation.additional_rates_part_1} ${rates.shipping_rates.length} ${
              window.PXUTheme.translation.additional_rates_part_2
            } ${this.zip.value}, ${this.provinceSelect.value}, ${this.countrySelect.value}, ${window.PXUTheme.translation.additional_rates_part_3} ${this.formatPrice(
              rates.shipping_rates[0].price
            )}`;
          } else {
            this.message.innerHTML = `${window.PXUTheme.translation.additional_rate} ${this.zip.value}, ${this.provinceSelect.value}, ${this.countrySelect.value}, ${
              window.PXUTheme.translation.additional_rate_at
            } ${this.formatPrice(rates.shipping_rates[0].price)}`;
          }

          this.response.classList.add("shipping-rates--display-rates");
        } else {
          this.message.innerHTML = `Error: ${propertyName[0]} ${rates[propertyName[0]]}`;
          this.response.classList.add("shipping-rates--display-error");
        }
      }

      clearRates() {
        this.response.classList.remove("shipping-rates--display-error", "shipping-rates--display-rates");
        this.message.innerHTML = "";
        this.rates.innerHTML = "";
      }

      formatPrice(price) {
        let formattedPrice;

        if (window.PXUTheme.currency.display_format === "money_with_currency_format") {
          formattedPrice = `<span class="money">${window.PXUTheme.currency.symbol}${price} ${window.PXUTheme.currency.iso_code}</span>`;
        } else {
          formattedPrice = `<span class="money">${window.PXUTheme.currency.symbol}${price}</span>`;
        }

        return formattedPrice;
      }

      unload() {
        this.events.unregisterAll();
      }
    } // CONCATENATED MODULE: ./source/scripts/app.js

    // Section Shopify window.PXUTheme.theme editor events

    $(document).on("shopify:section:reorder", function (e) {
      var $target = $(e.target);
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);

      if (window.PXUTheme.jsHeader.enable_overlay == true) {
        window.PXUTheme.jsHeader.unload();
        window.PXUTheme.jsHeader.updateOverlayStyle(window.PXUTheme.jsHeader.sectionUnderlayIsImage());
      }
    });

    $(document).on("shopify:section:load", function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById("shopify-section-" + e.detail.sectionId);

      // Blocks within section
      var $jsSectionBlocks = $section.find(".shopify-section[class*=js]");

      var sectionObjectUrl = $section.find("[data-theme-editor-load-script]").attr("src");

      // Check classes on schema and look for js (eg. jsMap)
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];

          // Check to see if section script exists
          if (typeof window.PXUTheme[triggerClass] == "undefined") {
            // make AJAX call to load script
            window.PXUTheme.loadScript(triggerClass, sectionObjectUrl, function () {
              window.PXUTheme[triggerClass].init($(section));
            });
          } else {
            if (window.PXUTheme[triggerClass]) {
              // console.log('Section: ' + triggerClass + ' has been loaded.')
              window.PXUTheme[triggerClass].init($(section));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.init() function exists.');
            }
          }
        }
      }

      // Check classes on block element and look for js (eg. jsMap)
      if ($jsSectionBlocks.length > 0) {
        var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
          for (var i = 0; i < this.classList.length; i++) {
            if (this.classList[i].substring(0, 2) === "js") {
              var triggerClass = this.classList[i];
              var $block = $("." + triggerClass);
              var blockUrl = $block.find("[data-theme-editor-load-script]").attr("src");

              // Check to see if section script exists
              if (typeof window.PXUTheme[triggerClass] == "undefined") {
                // make AJAX call to load script
                window.PXUTheme.loadScript(triggerClass, blockUrl, function () {
                  window.PXUTheme[triggerClass].init($block);
                });
              } else {
                if (window.PXUTheme[triggerClass]) {
                  // console.log('Block: ' + triggerClass + ' has been loaded.')
                  window.PXUTheme[triggerClass].init($(this));
                } else {
                  // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.init() function exists.');
                }
              }
            }
          }
        });
      }

      // Load video feature
      window.PXUTheme.video.init();

      // Scrolling animations
      window.PXUTheme.animation.init();

      // Initialize reviews
      window.PXUTheme.productReviews.init();

      // Object Fit Images
      window.PXUTheme.objectFitImages.init();

      // Infinite scrolling
      window.PXUTheme.infiniteScroll.init();

      // Disclosure menus
      window.PXUTheme.disclosure.enable();

      // Search
      $(document).on("click", "[data-show-search-trigger]", function () {
        window.PXUTheme.jsHeader.showSearch();
      });

      $(".search-overlay__close").on("click", function () {
        window.PXUTheme.jsHeader.hideSearch();
      });

      if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
        window.PXUTheme.predictiveSearch.init();
      }
      // Product review scroll
      window.PXUTheme.productReviews.productReviewScroll();
    });

    $(document).on("shopify:section:unload", function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById("shopify-section-" + e.detail.sectionId);

      // Blocks within section
      var $jsSectionBlocks = $section.find(".shopify-section[class*=js]");

      // Check classes on schema and look for js (eg. jsMap)
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];
          if (window.PXUTheme[triggerClass]) {
            // console.log('Section: ' + triggerClass + ' is unloaded.')
            window.PXUTheme[triggerClass].unload($(section));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.unload() function exists.');
          }
        }
      }

      // Check classes on block element and look for js (eg. jsMap)
      if ($jsSectionBlocks.length > 0) {
        var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
          for (var i = 0; i < this.classList.length; i++) {
            if (this.classList[i].substring(0, 2) === "js") {
              var triggerClass = this.classList[i];
              if (window.PXUTheme[triggerClass]) {
                // console.log('Block: ' + triggerClass + ' is unloaded.')
                window.PXUTheme[triggerClass].unload($(this));
              } else {
                // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.unload() function exists.');
              }
            }
          }
        });
      }

      // Scrolling animations
      window.PXUTheme.animation.unload($section);

      // QuantityBox
      window.PXUTheme.quantityBox.unload($section);

      // Infinite scrolling
      window.PXUTheme.infiniteScroll.unload($section);

      // Disclosure menus
      window.PXUTheme.disclosure.enable();
    });

    $(document).on("shopify:section:select", function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById("shopify-section-" + e.detail.sectionId);

      // Force show state when section is selected in theme editor
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];
          if (window.PXUTheme[triggerClass].showThemeEditorState) {
            window.PXUTheme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
          }
        }
      }

      // Predictive search
      if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
        window.PXUTheme.predictiveSearch.init();
      }

      if ($(".tabs").length > 0) {
        window.PXUTheme.tabs.enableTabs();
      }

      if (isScreenSizeLarge() && window.PXUTheme.jsHeader.enable_overlay === true) {
        window.PXUTheme.jsHeader.updateOverlayStyle(window.PXUTheme.jsHeader.sectionUnderlayIsImage());
      }

      if ($(".block__recommended-products").length > 0) {
        var $productPage = $(".block__recommended-products").parents(".product-page");
        window.PXUTheme.jsRecommendedProducts.init($productPage);
      }
    });

    $(document).on("shopify:section:deselect", function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById("shopify-section-" + e.detail.sectionId);

      // Force hide state when section is selected in theme editor
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];
          if (window.PXUTheme[triggerClass].showThemeEditorState) {
            window.PXUTheme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
          }
        }
      }
    });

    // Block Shopify window.PXUTheme.theme editor events

    $(document).on("shopify:block:select", function (e) {
      var blockId = e.detail.blockId;
      var $parentSection = $("#shopify-section-" + e.detail.sectionId);
      var $block = $("#shopify-section-" + blockId);

      if ($(".jsFeaturedPromos").length > 0) {
        window.PXUTheme.jsFeaturedPromos.blockSelect($parentSection, blockId);
      }

      if ($(".jsSlideshowWithText").length > 0) {
        window.PXUTheme.jsSlideshowWithText.blockSelect($parentSection, blockId);
      }

      if ($(".jsSlideshowClassic").length > 0) {
        window.PXUTheme.jsSlideshowClassic.blockSelect($parentSection, blockId);
      }

      if ($(".jsTestimonials").length > 0) {
        window.PXUTheme.jsTestimonials.blockSelect($parentSection, blockId);
      }

      // Sidebar collection multi-tag filter
      if ($block.hasClass("sidebar__block")) {
        var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
        if ($toggleBtn) {
          window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
        }
      }

      // Predictive search
      if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
        window.PXUTheme.predictiveSearch.init();
      }

      // Scrolling animations
      window.PXUTheme.animation.init();

      // Object Fit Images
      window.PXUTheme.objectFitImages.init();
    });

    $(document).on("shopify:block:deselect", function (e) {
      var $block = $("#shopify-section-" + e.detail.blockId);

      if ($block.hasClass("sidebar__block")) {
        var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
        if ($toggleBtn) {
          window.PXUTheme.jsSidebar.closeSidebarBlock($toggleBtn);
        }
      }
    });

    $(document).on("shopify:block:load", function (e) {});

    // Document ready
    $(function () {
      var $jsSections = $(".shopify-section[class*=js]");

      // Loop through sections with js classes and load them in
      var $jsSectionNames = $jsSections.each(function () {
        for (var i = 0; i < this.classList.length; i++) {
          if (this.classList[i].substring(0, 2) === "js") {
            var triggerClass = this.classList[i];
            if (window.PXUTheme[triggerClass]) {
              // console.log('Section: ' + triggerClass + ' has been loaded.')
              window.PXUTheme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.init() function exists.');
            }
          }
        }
      });

      var resizeTimer;

      // Store window width in variable
      var width = $(window).width(),
        height = $(window).height();

      $(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          window.PXUTheme.objectFitImages.calculateAspectRatio();

          if (window.PXUTheme.jsHeader.header_layout === "vertical") {
            window.PXUTheme.predictiveSearch.alignVerticalSearch();
          }

          if (!isScreenSizeLarge()) {
            // When 798 or less
            window.PXUTheme.mobileMenu.init();
          } else {
            // When larger than 798
            window.PXUTheme.mobileMenu.unload();
          }
        }, 250);
      });

      //Enable plyr
      window.PXUTheme.video.init();

      // Predictive search
      if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
        window.PXUTheme.predictiveSearch.init();
      }

      window.PXUTheme.dropdownMenu();

      window.PXUTheme.disclosure.enable();

      // Scrolling animations
      window.PXUTheme.animation.init();

      // QuantityBox
      window.PXUTheme.quantityBox.init();

      /* Show associated variant image on hover */
      if (window.PXUTheme.theme_settings.show_collection_swatches == true) {
        window.PXUTheme.thumbnail.enableSwatches();
      }

      /* Show secondary image on hover */
      if (window.PXUTheme.theme_settings.show_secondary_image == true) {
        window.PXUTheme.thumbnail.showVariantImage();
      }

      // Quick shop
      if (window.PXUTheme.theme_settings.enable_quickshop) {
        window.PXUTheme.thumbnail.showQuickShop();
      }

      // Currency converter
      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.init();
      }

      //Infinite scrolling
      if ($("[data-custom-pagination]").length) {
        window.PXUTheme.infiniteScroll.init();
      }

      //Select event for native multi currency checkout
      $(".shopify-currency-form select").on("change", function () {
        $(this).parents("form").submit();
      });

      // Tabs
      if ($(".tabs").length > 0) {
        window.PXUTheme.tabs.enableTabs();
      }

      // Additional checkout buttons
      if (!isScreenSizeLarge()) {
        $(".additional-checkout-buttons").addClass("additional-checkout-buttons--vertical");
      }

      // Accordion
      if ($(".accordion, [data-cc-accordion]").length > 0) {
        window.PXUTheme.contentCreator.accordion.init();
      }

      // Backwards compatiblity for Flexslider
      if ($(".slider, .flexslider").length > 0) {
        window.PXUTheme.contentCreator.slideshow.init();
      }

      // Object Fit Images
      window.PXUTheme.objectFitImages.init();

      // Responsive Video
      window.PXUTheme.responsiveVideo.init();

      // Flickity IOS Fix
      window.PXUTheme.flickityIosFix();

      // Product review scroll
      window.PXUTheme.productReviews.productReviewScroll();

      if (window.PXUTheme.theme_settings.shipping_calculator_enabled && document.querySelector("[data-shipping-calculator]")) {
        const shippingCalculator = new ShippingCalculator({
          el: document.querySelector("[data-shipping-calculator]"),
        });
      }

      /*================================================
              Custom JS - Jquery
    ================================================*/

      /*  Color Swatches
  ================================================*/

      // Open swatch dropdown
      $(".selected-swatch-dd").on("click", function () {
        $("ul.dropdownwithswatch").toggle();
      });

      // Select from the swatch dropdown
      $("ul.dropdownwithswatch").on("click", "li", function () {
        setVariantSelect($(this).attr("var-id"));
        $(this).closest("ul.dropdownwithswatch").toggle();
      });

      // Select from the radio button
      $(".swatch_options").on("click", ".swatch-element", function () {
        setVariantSelect($(this).attr("var-id"));
      });

      // Hide dropdown if click out of the area
      $(document).mouseup(function (e) {
        var container = $("ul.dropdownwithswatch");

        // If the target of the click isn't the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.hide();
        }
      });

      // Get variant id
      const getVariantId = () => {
        return $("variant-selection").attr("variant");
      };

      const getVariantHtml = (variantId) => {
        return $('ul.dropdownwithswatch li[var-id="' + variantId + '"]');
      };

      // Show the variants images in the carousel
      const showVariantAssociatedImages = (variantName) => {
        const allVariantImages = $('.product-gallery__thumbnails .product-gallery__thumbnail:not([data-title="all"])').hide();
        const selectedVariantImages = $('.product-gallery__thumbnails .product-gallery__thumbnail[data-title="' + variantName + '"]');

        allVariantImages.hide();
        if (selectedVariantImages.length) {
          selectedVariantImages.show();
        } else {
          allVariantImages.show();
        }
      };

      const getVariantData = (variantId) => {
        return $('ul.dropdownwithswatch li[var-id="' + variantId + '"] div').data();
      };

      // Set the selected variant in the selectbox input
      const setVariantSelect = (variantId) => {
        if (!variantId) {
          var variantId = getVariantId();
        }
        const variantData = getVariantData(variantId);

        // Set the main variant select
        $("variant-selection").attr("variant", variantId);

        // Draw the selected variant on top of dropdown
        var variantHtml = getVariantHtml(variantId);
        $(".selected-swatch-dd").html(variantHtml.html());

        // Set the selected variant on the radio options
        $('.swatch_options input[var-id="' + variantId + '"]').prop("checked", true);

        // Set variant name
        if ("description" in variantData && ![false, 0, "", null, undefined, NaN].includes(variantData.description)) {
          $(".options-selection__option-name span").html(variantData.name + " - " + variantData.description);
        } else {
          $(".options-selection__option-name span").html(variantData.name);
        }

        // Update variants images in the carousel
        showVariantAssociatedImages(variantData.name);
      };

      // Auto select swatch drop down on page load
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      // Check if product template
      if (window.PXUTheme.product_page) {
        if ("variant" in params) {
          setVariantSelect(params.variant);
        } else {
          setVariantSelect($(".dropdownwithswatch li:first-child").attr("var-id"));
        }
      }
    });

    // add class on scroll
    $(document).ready(function () {
      // External variables from child-app.js
      var targetElSelector = "body";
      var classToAdd = "page-is-scrolled";
      var offsetNumber = 100;

      var elements = {
        targetEl: $(targetElSelector),
        classEl: classToAdd,
        offsetNumber: offsetNumber,
      };

      // Event listener on scroll
      $(window).on("scroll", function () {
        toggleInit();
      });

      // Toggle function
      function toggleInit() {
        if (window.pageYOffset >= elements.offsetNumber) {
          elements.targetEl.addClass(elements.classEl);
        } else {
          elements.targetEl.removeClass(elements.classEl);
        }
      }
    });

    // limit address field characters
    document.addEventListener("DOMContentLoaded", function () {
      var addressField = document.querySelector("#shipping-address1");
      if (addressField) {
        addressField.setAttribute("maxlength", "50");

        addressField.addEventListener("input", function () {
          if (this.value.length > 50) {
            this.value = this.value.substring(0, 50);
          }
        });

        addressField.addEventListener("blur", function () {
          if (this.value.length > 50) {
            this.value = this.value.substring(0, 50);
          }
        });
      }
    });

    // product tabs
    $(document).ready(function () {
      $(".tab .tab__heading[data-tab='0'], .tab .tab__content-item[data-tab='0']").addClass("is-active");

      $(".tab .tab__heading").click(function () {
        var dataTab = $(this).attr("data-tab");

        $(".tab .tab__content-item, .tab .tab__heading").removeClass("is-active");

        $(".tab .tab__heading[data-tab='" + dataTab + "']").addClass("is-active");
        $(".tab .tab__content-item[data-tab='" + dataTab + "']").addClass("is-active");
      });
    });

    // country dropdown
    $(document).ready(function () {
      setTimeout(function () {
        $(".wsscc-drop-item").each(function () {
          var $currentItem = $(this);
          var currencyText = $currentItem.find(".ws-curreny-text").text().toLowerCase().replace(/\s+/g, "-");
          $currentItem.addClass(currencyText);
        });
      }, 1000);
    });

    // remove cart cookie if switching countries
    document.addEventListener("DOMContentLoaded", function () {
      function delete_cookie(name) {
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      }

      // Deselect all options for each instance
      function updateSelection() {
        var allInstances = document.querySelectorAll(".variant-selection__variants");

        // Function to update the country attribute and local storage
        function updateCountry(country) {
          // Get the current country from local storage
          var previousCountry = localStorage.getItem("country");

          // Check if the country has changed
          if (previousCountry !== country) {
            // Update the country in local storage
            localStorage.setItem("country", country);
            console.log("Country updated:", country);

            // Clear cart
            // window.location.href = "/cart/clear";
            delete_cookie("cart");
          }
        }

        allInstances.forEach(function (instance) {
          // Check if there is an element with class 'disclosure-list__item--current' and value 'GB'
          // var isUK = document.querySelector(".wssccSelectedDropdownItem .currency-flag-gb, .wssccSelectedDropdownItem .fflag-GB");

          var isUK = $("body").attr("data-money-format") === "£{{amount}}";

          if (isUK) {
            // Auto select the option with name 'uk'
            document.body.setAttribute("country", "UK");

            var optionUK = instance.querySelector("option[name='uk']");
            if (optionUK) {
              optionUK.selected = true;
            }

            // Deselect the option with name 'ie'
            var optionIE = instance.querySelector("option[name='ie']");
            if (optionIE) {
              optionIE.selected = false;
            }

            // Update the country
            updateCountry("UK");
          }

          // Check if there is an element with class 'disclosure-list__item--current' and value 'IE'
          // var isIE = document.querySelector(
          //   ".wssccSelectedDropdownItem .currency-flag-ie, .wssccSelectedDropdownItem .currency-flag-gb, .wssccSelectedDropdownItem .fflag-IE"
          // );

          var isIE = $("body").attr("data-money-format") === "€{{amount_with_comma_separator}}";

          if (isIE) {
            // Auto select the option with name 'ie'
            document.body.setAttribute("country", "IE");

            var money = $(".money");
            money.attr("ws-currency", "EUR");

            var optionIE = instance.querySelector("option[name='ie']");
            if (optionIE) {
              optionIE.selected = true;
            }

            // Deselect the option with name 'uk'
            var optionUK = instance.querySelector("option[name='uk']");
            if (optionUK) {
              optionUK.selected = false;
            }

            // Update the country
            updateCountry("IE");
          }

          // Update the .variant-selection parent element with a custom attribute
          var selectedValue = instance.querySelector("option:checked").value;

          console.log(selectedValue);
          $(instance).parents(".variant-selection").attr("variant", selectedValue);
        });
      }

      // call update to cart and variant option after page load
      window.addEventListener("load", function () {
        setTimeout(function () {
          updateSelection();
        }, 500);
      });
    });

    // set price correctly
    // $(document).ready(function () {
    //   var updateCount = 0;

    //   console.log("updateCount", updateCount);

    //   // Function to update the HTML content with the value of ws-price attribute and add currency sign
    //   function updatePriceFromAttribute() {
    //     // Select all elements with the class "money done"
    //     $(".money.done").each(function () {
    //       // Get the value of the ws-price attribute for the current element
    //       var price = $(this).attr("ws-price");
    //       price = parseFloat(price).toFixed(2);

    //       // Get the value of the ws-currency attribute for the current element
    //       var currency = $(this).attr("ws-currency");
    //       var dataMoneyFormat = $("body").attr("data-money-format");

    //       // Check the currency value to determine the currency sign
    //       if (dataMoneyFormat === "€{{amount_with_comma_separator}}") {
    //         // If currency is "EUR", add euro sign
    //         $(this).html("€" + (price / 100).toFixed(2));
    //       } else if (dataMoneyFormat === "£{{amount}}") {
    //         // If currency is "EUR", add euro sign
    //         $(this).html("£" + price);
    //       } else if (currency === "EUR") {
    //         // If currency is "EUR", add euro sign
    //         $(this).html("€" + (price / 100).toFixed(2));
    //       } else if (currency === "GBP") {
    //         // If currency is "GBP", add pound sign
    //         $(this).html("£" + price);
    //       }
    //     });
    //   }

    //   // Call the updatePriceFromAttribute function initially
    //   updatePriceFromAttribute();

    //   // Increment the updateCount
    //   updateCount++;

    //   // Check if updateCount is less than or equal to 3
    //   if (updateCount <= 3) {
    //     // If so, call updatePriceFromAttribute again after 5 seconds
    //     setInterval(function () {
    //       updatePriceFromAttribute();
    //     }, 3000);
    //   }
    // });

    // reload page after products page is filtered
    let previousUrl = window.location.href;
    const observer = new MutationObserver(function (mutations) {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href;
        location.reload();
      }
    });
    const config = { subtree: true, childList: true };

    // start listening to changes
    observer.observe(document, config);

    /*============================================================================
Slideshow arrows
==============================================================================*/

    if (window.PXUTheme.theme_settings.icon_style == "icon_solid") {
      window.arrowShape = "M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z";
    } else {
      window.arrowShape =
        "M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z";
    }
  })();

  // ADD WIDTH TO IMAGE BASED ON PARENT CONTAINER
  // Function to get and update parent container width for all images
  function updateParentContainerWidth() {
    // Get all img elements within .gallery__item
    const imgElements = document.querySelectorAll(".before-and-afters-container .gallery__item img");

    imgElements.forEach((imgElement) => {
      // Get the parent container element (.gallery__item)
      const parentContainer = imgElement.closest(".gallery__item");

      if (parentContainer) {
        // Function to update img width based on parent container width
        function updateImgWidth() {
          const parentWidth = parentContainer.offsetWidth;
          imgElement.style.width = parentWidth + "px";
          console.log("Updated Image Width:", parentWidth);
        }

        // Initial update
        updateImgWidth();

        // Update the width when the viewport resizes
        window.addEventListener("resize", updateImgWidth);
      } else {
        console.error("Parent container not found. Check your HTML structure.");
      }
    });
  }

  // Call the function to initialize
  updateParentContainerWidth();

  // BEFORE AND AFTER SLIDER
  // Function to create a before-and-after image slider
  let wrappers = document.querySelectorAll(".wrapper");

  // Iterate over each wrapper
  wrappers.forEach((wrapper) => {
    let active = false;

    // Set up event listeners for the current wrapper
    wrapper.querySelector(".scroller").addEventListener("mousedown", function () {
      active = true;
      wrapper.querySelector(".scroller").classList.add("scrolling");
    });

    document.body.addEventListener("mouseup", function () {
      active = false;
      wrapper.querySelector(".scroller").classList.remove("scrolling");
    });

    document.body.addEventListener("mouseleave", function () {
      active = false;
      wrapper.querySelector(".scroller").classList.remove("scrolling");
    });

    document.body.addEventListener("mousemove", function (e) {
      if (!active) return;
      let x = e.pageX;
      x -= wrapper.getBoundingClientRect().left;
      scrollIt(x, wrapper);
    });

    wrapper.querySelector(".scroller").addEventListener("touchstart", function () {
      active = true;
      wrapper.querySelector(".scroller").classList.add("scrolling");
    });

    document.body.addEventListener("touchend", function () {
      active = false;
      wrapper.querySelector(".scroller").classList.remove("scrolling");
    });

    document.body.addEventListener("touchcancel", function () {
      active = false;
      wrapper.querySelector(".scroller").classList.remove("scrolling");
    });

    // Function to handle scrolling for the current wrapper
    function scrollIt(x, currentWrapper) {
      let transform = Math.max(0, Math.min(x, currentWrapper.offsetWidth));
      currentWrapper.querySelector(".after").style.width = transform + "px";
      currentWrapper.querySelector(".scroller").style.left = transform - 25 + "px";
    }

    // Set initial state based on the width
    scrollIt(150, wrapper);
  });

  // before and after filter
  jQuery(document).ready(function ($) {
    // Function to handle filter
    function handleFilter(category) {
      // Remove active class from all filters
      $(".before-and-afters-filter__item").removeClass("active");

      // Add active class to the clicked filter
      $(".before-and-afters-filter__item[data-category=" + category + "]").addClass("active");

      // Hide all items
      $(".gallery__item").hide();

      // Add category as title
      $(".before-and-afters-filter__title").html(category);

      // Show only items with the selected category
      if (category === "all") {
        $(".gallery__item").show();
        $(".before-and-afters-filter__item[data-category='all']").addClass("active");
      } else {
        $(".gallery__item[data-category-" + category + "]").show();
      }
    }

    // Handle filter button click
    $(".before-and-afters-filter__item").on("click", function () {
      var category = $(this).data("category");
      handleFilter(category);

      // Store the selected category in local storage
      localStorage.setItem("selectedCategory", category);
    });

    // Handle click event for "all" filters
    $(".before-and-afters-filter__item[data-category='all']").on("click", function () {
      $(".before-and-afters-filter__item").removeClass("active");
      $(this).addClass("active");
      $(".gallery__item").show();

      // Remove selected category from local storage
      localStorage.removeItem("selectedCategory");
    });

    // On page load, check if a category is stored in local storage
    $(document).ready(function () {
      var storedCategory = localStorage.getItem("selectedCategory");

      if (storedCategory) {
        // Call the function to handle the filter
        handleFilter(storedCategory);
      } else {
        // If no category is stored, show all items
        $(".gallery__item").show();
        $(".before-and-afters-filter__item[data-category='all']").addClass("active");
      }
    });
  });

  /******/
})();
